import type { TPanelPlacement } from 'stores/detailsPanelStore/detailsPanelStore'

export const getPanelStateAfterDrag = ({
  placement,
  size,
  maxSize,
}: {
  placement: TPanelPlacement
  size: number
  maxSize: number
}) => {
  if (size <= 0) return { isPanelOpen: false, draggedPanelSize: null }

  return { isPanelOpen: true, draggedPanelSize: size >= maxSize ? null : { placement, size } }
}
